// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2y67o","right":"Footer_right__1BhfT","buttons":"Footer_buttons__1BGrE"};